import classNames from 'classnames';
import styles from './styles.module.css';

export const Closing = ({ type, brand }) => {
    return <div className={classNames(styles.root, styles[`theme-${brand.theme}-${type}`])} />;
};
